<template>
  <v-card>
     <v-dialog v-model="dialogAddPlace" persistent max-width="600px">
      <v-card class="text-center">
        <v-card-title>
          <v-layout row wrap>
          <v-flex xs12><v-text-field
            label="Nowe miejsce"
            v-model="new_place.place"
            block
          ></v-text-field>
</v-flex>
<v-flex>
         <v-autocomplete
          :items="country"
          label="Państwo"
          v-model="new_place.country"
          />
        </v-flex>
        </v-layout>
        </v-card-title>
        <v-card-actions>
           <v-btn
            color="black"
            text
            @click="dialogAddPlace = false"
          >
         
            {{$t("close")}}
          </v-btn>
          <v-btn
            color="red"
            text
            :disabled="isExist()"
            @click="addplace()"
          >
            {{$t("add")}}
          </v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
    <v-toolbar dense color="transparent">
      <v-toolbar-title><h4>Miejsca</h4></v-toolbar-title>
      <v-spacer></v-spacer>
       <v-btn @click="deleteon = !deleteon" icon>
        <v-icon>remove</v-icon>
      </v-btn>
      <v-btn @click="dialogAddPlace = true" icon>
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table :mobile-breakpoint='200' no-data-text="Brak rekordów" hide-default-headers :items-per-page=1000 :headers="headers" :items="itemsPlaces" hide-default-footer class="elevation-0 table-striped">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.place_key }}
             </td>   
          </template>
             <template v-slot:item.action="{ item }">
    <div v-if="deleteon" class="text-xs-right"><v-btn @click="deleteplace(item.place_key)" text small icon ><v-icon>delete_outline</v-icon></v-btn></div>
    </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>
<script>
const axios = require('axios');
import moment from 'moment'
export default {
   computed: {
    places(){
      return this.store.state.places;
    },
    dateNow(){
      return this.store.state.dateNow;
    },
    sortby(){
      return this.store.state.sortby
    }
  },
  watch:{
      sortby: {
      handler: function(newValue,oldValue) {
      this.sort = newValue;
     
      },
      deep: true
    },
     places: {
      handler: function(newValue) {
      this.itemsPlaces = newValue;

      },
      deep: true
    },
        dateNow: {
      handler: function(newValue,oldValue) {
      this.dataNow = newValue;
      },
      deep: true
    },
  },
  data() {
    return {
      headers: [
        { text: "Miejsce", value: "place_key"},
      {value:"action"}
      ],
      itemsPlaces: this.store.state.places || [],
      dialogAddPlace:false,
      new_place:{place:null,country:null},
      country:null,
      sort:null,
      country:["NL","DE","FR","ES","IT","CZ","SL","PL","LU","BELGIA","AUSTRIA"],
      deleteon:false,
    }
  },
  mounted(){
  },
  methods: {
       isExist(){
   if(this.new_place.place){ 
   if(this.itemsPlaces.some(place => place.place_key === this.new_place.place)){
        return true
    } else{
        return false   
    }
  }
   },
    driveCheck(arrive,left){
      let now = moment().utc();
      let arrived = moment(arrive);
      let lefted = moment(left);
      if(now < arrived)  return true
        else return false
    },
    converttime(arrived,lefted) {
    let now = moment().utc();
    let arrive = moment(arrived)
    let left =  moment(lefted)
     let  alltimedrive = left.diff(arrive,'hours');
     let realtimedrive = now.diff(left,'hours');
      if(realtimedrive>0)return  Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))
        else return 0
  },
    getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    },
    refresh(){
  var data = this;
  var jwt = this.getCookie('jwt');
  axios.post('http://' + location.hostname + '/transportapp/php_file/validation_token.php', {
           jwt :jwt,
           data: data.dateNow,
           sortby:data.sort
    })
  .then(function (response) {
    if ( response.data.message == "access" ){
     data.store.state.routes = JSON.parse(response.data.routes);
      data.store.state.cars = JSON.parse(response.data.cars);
      data.store.state.places = JSON.parse(response.data.places);
      data.store.state.allcars = JSON.parse(response.data.allcars);
    } else if ( response.data.message == "denied" ) {
        data.$router.push('/auth/login');
    }
  })
 },
     addplace(){
     var data=this;
     var jwt = this.getCookie('jwt');
     axios.post('http://'+location.hostname+'/transportapp/php_file/addplace.php', {
           jwt :jwt,
           key_place: data.new_place.place,
           country:data.new_place.country
    })
     .then(function (response) {
      console.log(response)
      data.dialogAddPlace = false;
      data.refresh();
      data.new_place={place:null,country:null};
    
     })
     .catch(function (error) {
       console.log(error);
     });
},
 deleteplace(value){
     var data=this;
     var jwt = this.getCookie('jwt');
     axios.post('http://'+location.hostname+'/transportapp/php_file/deleteplace.php', {
           jwt :jwt,
           key_place: value
    })
     .then(function (response) {
      data.refresh();
    
     })
     .catch(function (error) {
       console.log(error);
     });
    
},
  }
}
</script>
